export default function Privacy() {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.logo}>TxtMyCar</div>
        <h1 style={styles.title}>Privacy Policy</h1>
        <p style={styles.updated}>Last updated: February 2026</p>

        <div style={styles.content}>
          <section style={styles.section}>
            <h2 style={styles.h2}>1. Who We Are</h2>
            <p>TxtMyCar operates the website <a href="https://txtmycar.co.uk" style={styles.link}>txtmycar.co.uk</a>. We are the data controller for the personal information you provide when using our service. If you have any questions about how we handle your data, contact us at <a href="mailto:hello@txtmycar.co.uk" style={styles.link}>hello@txtmycar.co.uk</a>.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>2. What Data We Collect</h2>
            <p>When you register, we collect:</p>
            <ul style={styles.list}>
              <li>Your name and email address</li>
              <li>Your postal address (to send your vehicle sticker)</li>
              <li>Your vehicle registration number(s)</li>
              <li>The mobile number associated with each vehicle</li>
              <li>Payment records (handled by Stripe — we do not store card details)</li>
              <li>Messages sent through the platform and their delivery status</li>
            </ul>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>3. How We Use Your Data</h2>
            <p>We use your data solely to operate the TxtMyCar service:</p>
            <ul style={styles.list}>
              <li>To send SMS messages to your registered mobile number when another user contacts your vehicle</li>
              <li>To send your free sticker to your postal address</li>
              <li>To process payments and maintain your credit balance</li>
              <li>To investigate misuse of the platform</li>
              <li>To send you service-related emails (no marketing without your consent)</li>
            </ul>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>4. Who We Share Your Data With</h2>
            <p>We share your data only with the third-party services required to operate TxtMyCar:</p>
            <ul style={styles.list}>
              <li><strong style={{ color: '#f0f0f4' }}>Twilio</strong> — to deliver SMS messages to your mobile number</li>
              <li><strong style={{ color: '#f0f0f4' }}>Stripe</strong> — to process payments securely</li>
            </ul>
            <p style={{ marginTop: 12 }}>We do not sell your personal data to any third party.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>5. Message Visibility</h2>
            <p>When someone sends a message to your vehicle, the sender's registration number is included in the SMS you receive. The sender does not receive your name, mobile number, email, or any other personal information — only the ability to send you a message.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>6. Data Retention</h2>
            <p>We retain your account data for as long as your account is active. Message logs are retained for up to 12 months. You may request deletion of your account and associated data at any time by emailing <a href="mailto:hello@txtmycar.co.uk" style={styles.link}>hello@txtmycar.co.uk</a>.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>7. Your Rights</h2>
            <p>Under UK GDPR, you have the right to:</p>
            <ul style={styles.list}>
              <li>Access the personal data we hold about you</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to or restrict processing of your data</li>
              <li>Lodge a complaint with the ICO at <a href="https://ico.org.uk" style={styles.link}>ico.org.uk</a></li>
            </ul>
            <p style={{ marginTop: 12 }}>To exercise any of these rights, email <a href="mailto:hello@txtmycar.co.uk" style={styles.link}>hello@txtmycar.co.uk</a>.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>8. Cookies</h2>
            <p>TxtMyCar does not use tracking or advertising cookies. We use browser localStorage solely to keep you logged in to your account.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>9. Security</h2>
            <p>All data is transmitted over HTTPS. Passwords are stored using industry-standard bcrypt hashing. We do not store card details — all payment processing is handled by Stripe.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>10. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by email. Continued use of the service after changes are posted constitutes acceptance.</p>
          </section>
        </div>

        <div style={styles.footer}>
          <a href="/signup" style={styles.link}>&larr; Back to sign up</a>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page:       { minHeight: '100vh', background: '#0f0f13', color: '#f0f0f4', fontFamily: "'DM Sans', sans-serif", padding: '40px 20px' },
  container:  { maxWidth: 720, margin: '0 auto' },
  logo:       { fontFamily: 'Syne, sans-serif', fontSize: 20, fontWeight: 800, color: '#e8ff47', marginBottom: 32 },
  title:      { fontFamily: 'Syne, sans-serif', fontSize: 36, fontWeight: 800, letterSpacing: -1, marginBottom: 8 },
  updated:    { color: '#7a7a94', fontSize: 14, marginBottom: 40 },
  content:    { lineHeight: 1.8, fontSize: 15 },
  section:    { marginBottom: 36, borderBottom: '1px solid #2a2a38', paddingBottom: 36 },
  h2:         { fontFamily: 'Syne, sans-serif', fontSize: 18, fontWeight: 700, color: '#e8ff47', marginBottom: 12 },
  list:       { paddingLeft: 20, marginTop: 8, lineHeight: 2, color: '#c0c0d0' },
  link:       { color: '#e8ff47', textDecoration: 'none' },
  footer:     { marginTop: 40, paddingTop: 24, borderTop: '1px solid #2a2a38' },
};
